import { APIFactory } from '../api/api.factory'
const CarRentalAPI = APIFactory.get('carRental')

export default {
    async getCarRental(erID) {
        const { data } = await CarRentalAPI.getCarRental(erID)
        return data;
    },
    async getRentalCarCompanyTypes() {
        const { data } = await CarRentalAPI.getRentalCarCompanyTypes()
        return data;
    },
    async getMoreThanCompactClassTypes() {
        const { data } = await CarRentalAPI.getMoreThanCompactClassTypes()
        return data;
    },
    async getAmountClaimedLessThanPaidReasons() {
        const { data } = await CarRentalAPI.getAmountClaimedLessThanPaidReasons()
        return data;
    }
}